import { ErrorFallback } from '@components/ErrorFallback';
import { ErrorBoundary } from '@datadog/browser-rum-react';
import { createRootRoute, Outlet } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: () => (
    <ErrorBoundary fallback={ErrorFallback}>
      <Outlet />
    </ErrorBoundary>
  ),
});
